'use client'
import React, { useState, useEffect } from 'react'
import PropertyCard from '@components/PropertyCard'
import AgentCard from '@components/AgentCard'
import { getRecommended } from '@services/getRecommended'
// import { useSession } from 'next-auth/react'
import dynamic from 'next/dynamic'
import { Suspense } from 'react'

const PropertyCardSlider = dynamic(() => import('@components/PropertyCardSlider'))


const RecommendedProperties = ({ property, dictionary, lang, limit = 3 }) => {
    // const { data: session } = useSession()
    let userEmail = null
    const [recommended, setRecommeneded] = useState([])

    // if (session !== null) {
    //     userEmail = session?.user?.email
    // }

    useEffect(() => {
        const setRecommenededData = async () => {

            const properties = await getRecommended(property.slug, userEmail, lang, 6)
            // console.log(properties.properties)
            setRecommeneded(properties.properties)
        }
        setRecommenededData()
    }, [])

    return (
        <div className='block w-full bg-light top-0 pt-3'>
            {/* <AgentCard property={property} className="mb-2" /> */}
            {recommended.length > 0 && (
                <PropertyCardSlider lang={lang} title={`Similar Listings for You`} dictionary={dictionary} properties={recommended} slidesPerView={3} slidesPerViewMobile={1.5} pl={0} />
            )}
        </div>
    )
}

export default RecommendedProperties